// extracted by mini-css-extract-plugin
export var errorIcon = "_nc-1";
export var nameLogo = "_nc-0";